<ng-container *ngFor="let alert of alerts">
    <ngb-alert type="light" [dismissible]="alert.dismissible" (closed)="closeAlert(alert)">
        <svg *ngIf="alert.icon" class="icon-alert"><use xlink:href="#icon-alert"></use></svg>
        <div class="message">{{ alert.message }}</div>
        <aurora-link-button 
                *ngIf="alert.action" 
                (click)="performAction(alert)">
            {{alert.action.label}}
        </aurora-link-button>
    </ngb-alert>
</ng-container>